export default __webpack_public_path__ + "static/media/photo-1551069613-1904dbdcda11.6380bd9d.jpeg";